export enum FeaturesEnum {
  StoryPerformance_KlmLink = 'KSS__story-performance-page__klm-link',
  StoriesList_KlmLink = 'KSS__stories-page__klm-link',
  StoriesList_Performance = 'KSS__StoriesList__Performance',
  Tech_GenerateError = 'Tech_GenerateError'
}
